import React from 'react';
import './CancelledOrder.css';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../../NewHeader/Layout';
import cimage from '../../../images/burger/b3.png';
import Pagination from 'react-js-pagination';
import Table from 'react-bootstrap/Table';
import Loader from '../../Loader/Loader';


const CancelledOrder = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [cancelledOrders, setCancelledOrder] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const [bookingOrder, setBookingorders] = useState([]);
  const [ itempopup, setItempopup ] = useState(false);
  const [ orderedItems, setorderItems ] = useState([]);
  const [ setOrdereditempopup, setOrderedItempopup ] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(false);
  const [isOpenRefund, setIsOpenRefund] = useState(false);
  const [refundOrder, setRefundOrder] = useState(false);


  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);  // Add leading zero to month
    const day = ("0" + currentDate.getDate()).slice(-2);  // Add leading zero to day
    return `${year}-${month}-${day}`;
  };

  // Function to format date as DD-MM-YYYY
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ("0" + date.getDate()).slice(-2);  // Add leading zero to day
    const month = ("0" + (date.getMonth() + 1)).slice(-2);  // Add leading zero to month
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;  // Return in DD-MM-YYYY format
  };

  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId")
});
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});

  // Effect to detect when fromDate becomes empty
  useEffect(() => {
    if (fromDate === '') {
      fetchTables();
    }
  }, [fromDate]);

console.log(formData)
const [currentPage, setCurrentPage] = useState(1);
 const [itemsPerPage] = useState(10); // Number of items per page
 const [searchTerm, setSearchTerm] = useState('');
 
 // Filtering tables based on search term
const filteredTables = tables.filter((item) => {
  const orderType = item.order_type === 1 ? "Normal Order" : item.order_type === 2 ? "Credit Order"  : "-";
  const payment = item.payment_status === 1 ? "Paid"  : "Not Paid";
  return (
    item.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) || // Optional chaining
    String(item.mobile_no || "").toLowerCase().includes(searchTerm.toLowerCase()) || // Provide default empty string for numbers
    item.order_no?.toLowerCase().includes(searchTerm.toLowerCase()) || 
    item.delivery_address?.toLowerCase().includes(searchTerm.toLowerCase()) || 
    item.reject_remarks?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.booking_dates[0]?.date || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
    String(item.rejected_date || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
    orderType.toLowerCase().includes(searchTerm.toLowerCase()) ||
    payment.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.amount || "").toLowerCase().includes(searchTerm.toLowerCase()) 
  );
});

 
 // Pagination logic
 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
 const totalItems = filteredTables.length;
 
 const handleSearchInput = (event) => {
   setSearchTerm(event.target.value);
   setCurrentPage(1); // Reset to the first page when search changes
 };
 
 const handlePageChange = (pageNumber) => {
   setCurrentPage(pageNumber);
 };

    useEffect(() => {
      const currentDate = getCurrentDate();
      fetchTables();
    }, []);


      const fetchTables = async (date = null) => {
        setLoading(true);
        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');

        try {
           
            const url = date
            ? `${var_api}booking-orders/cancelled-order-list/${shop_id}/${date}`
            : `${var_api}booking-orders/cancelled-order-list/${shop_id}`;
          
          const response = await axios.get(url, {
            headers: {
              Authorization: `${token}` // Ensure correct token format
            }
          });
            setLoading(false);
            console.log("Response received:", response);

            const user = response.data.data ;
            setTables(user);
        } catch (error) {
            setLoading(false);
            if (error.response && error.response.status === 401) {
              localStorage.removeItem('Token'); // Clear the invalid token
              history.push('/')// Redirect to the Sign-In page
            } else {
              console.error("Error fetching data:", error);
            }
        }
    };
   

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        (order.e_name && order.e_name.toString().toLowerCase().includes(searchLower)) ||
        (order.e_email && order.e_email.toString().toLowerCase().includes(searchLower))  ||
        (order.e_phone && order.e_phone.toString().toLowerCase().includes(searchLower))  ||
        (order.e_role && order.e_role.toString().toLowerCase().includes(searchLower)) 
      );
    });

//handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("files",file);
        setFormData({ ...formData, profile: file });
      };

//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};


    const handleRefund = (order) => {
      // Logic to handle refund
      // history.push('/Refund');
      setIsOpenRefund(true);
      setRefundOrder(order);
    };


  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setFromDate(selectedDate);  // Update state with selected date
    fetchTables(formatDate(selectedDate)); // Fetch data with the selected date
  };
  const handleshow =(data, order)=>{
    setBookingorders(data);
    setItempopup(true);
    setCurrentOrder(order)
  
  }
  const handleshowItems =(data)=>{
    setorderItems(data);
    setOrderedItempopup(true);
  }

  const updateRefundStatus = () => {
    const shop_id = localStorage.getItem("shopId");
    setLoading(true);
    const refundData = {
      is_refund: 1,
      refund_id: parseInt(shop_id),
      refund_time: new Date().toISOString().slice(0, 19).replace("T", " ")
    };
  
    const token = localStorage.getItem('Token');
    
    axios
      .put(`${var_api}booking-orders/update-refund-status/${refundOrder.id}`, refundData, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(async (response) => {
        if (response.status === 200) {
          Swal.fire("Success", "refund status updated successfully!", "success");
          await fetchTables();
          await sendRefundEmail();
          setIsOpenRefund(false);
        } else {
          Swal.fire("Error", "Failed to update refund status!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
        Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
      });
  };

  //send email
  const sendRefundEmail = async () => {

    setLoading(true);
    try {
    
      const response = await axios.post(
        `${var_api}booking-orders/send-refund-email/${refundOrder.id}`,
         // Convert to array if multiple emails are entered
      );

      if (response.status === 200) {
        console.log("Refund email sent successfully!");
      } else {
        console.log("Failed to send refund email.");
      }
    } catch (error) {
      console.log("Error sending email. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const [showGroupModal, setShowGroupModal] = useState(false);
    const [selectedGroupFoods, setSelectedGroupFoods] = useState([]);
  
    const handleGroupClick = (groupFoods) => {
      setSelectedGroupFoods(groupFoods);
      setShowGroupModal(true);
    };

return(
      <>         <Layout>
            <div class="splitco">
          
      <div style={{border:"none", padding:"15px", width:"103%", height:"630px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"5px"}}>
    
      {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"17px",float:"right",borderRadius:"10px"}}>Create Category</Button>{' '}
       */}
      <div>
    
     
       <div class="row">
         <div class="col">
         <h4 className='ushe'>CANCELLED ORDERS</h4>
         </div>
       <div class = "col">
       <div className="col" style={{ maxWidth: "250px", padding: "0" }}>
        <input
          type="date"
          className="form-control form-control-sm"
          id="fromDate"
          name="fromDate"
          style={{ fontSize: "15px", float: "right" }}
          value={fromDate}  // Bind the value to the selected date
          onChange={handleDateChange}  // Call the handler when the date is changed
        />
      </div>
       </div>
         <div class="col">
         <input class="form-control" type="Search" placeholder="Search" 
      style={{maxWidth:"230px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
         </div>
        
       </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll', marginTop:"5px" }}>
      <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
      <thead>
  <tr style={{ fontWeight: "bolder" }}>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">S.No</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Customer name</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Mobile</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Order Id</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Order Address</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Order Type</th>
    {/* <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Slot Name</th> */}
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Delivery Date</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Rejected Date</th>

    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Amount</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Rejected Remarks</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Paid Status</th>
    <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Action</th>

  </tr>
</thead>
{loading ? (
  <Loader />
) : (
  <tbody className="body-half-screen" style={{ fontSize: "14.5px" }}>
    {currentItems.length > 0 ? (
      currentItems.map((order, index) => (
        <tr key={order.sNo} style={{ padding: "4px" }}>
          <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>{indexOfFirstItem + index + 1}</th>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.customer_name}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.mobile_no}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" , color:"blue" }}>{order.order_no}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.delivery_address}</td>
          <td style={{
            textTransform: "capitalize",
            textAlign: "left",
            color: order.order_type === 1 ? "purple" : "orange",
            fontWeight: "bold"
          }}>
           {order.order_type === 1 ? "Normal Order" : order.order_type === 2 ? "Credit Order"  : "Pending"}
          </td>
          {/* <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.slot_name}</td> */}
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>  {order.booking_dates[0]?.date || '-'}</td>

                    <td style={{ textTransform: "capitalize", textAlign: "left" }}>  {order.rejected_date || '-'}</td>

          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.amount}</td>
          <td>{order.reject_remarks}</td>
          <td style={{
            textAlign: "left",
            color: order.payment_status === 0 ? "red" : "green",
            fontWeight: "bold"
          }}>
             <div className="d-flex align-items-center justify-content-between" style={{ width: "100%" }}>
             <span>{order.payment_status === 0 ? "Not Paid" : "Paid"}{" "}</span>{"  "}
             {
              order.is_refund == 1 && ( <span style={{marginLeft:"5px"}}>{order.is_refund == 0 ? "Not Refunded" : "Refunded"}{" "}</span>)
             }
             
            {order.payment_status === 1 && order.is_refund === 0 && (
              <Button
                variant="dark"
                onClick={()=>handleRefund(order)}
                style={{
                  padding: "2px 8px",
                  fontSize: "17px",
                  float: "right",
                  borderRadius: "10px",
                  marginLeft:"7px"
                }}
              >
                Refund
              </Button>
            )}
             </div>
          </td>
          <td>  <button
              className="btn btn-primary"
              onClick={() => handleshow(order.booking_dates, order)}
              style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
            </button></td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="11" style={{ textAlign: "center", color: "red", fontWeight: "bold", borderColor: "black" }}>
          No Cancelled Orders Found
        </td>
      </tr>
    )}
  </tbody>
)}

</table>
      </div>

      <Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
</div>
        </div>
      </div>

      <Modal
        show={isOpenRefund}
        onHide={()=>setIsOpenRefund(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"22px"}}>
          {/* <Modal.Title>confirmation</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4>
          <h6 className='text-dark' style={{textAlign:"center"}}>Are You Sure want to Refund for order no <b style={{color:"blue"}}>{refundOrder?.order_no}</b>
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setIsOpenRefund(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={()=>updateRefundStatus()}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>





      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Category </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2">
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Category Name</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Category Name" name='c_name' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"10px",height:"50px"}} required/>
               </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Category Code</label>
              <input type="text" class="form-control" id="floatingInput" placeholder="Category Code" name='c_code' value={formData.e_email} onChange={handleInputChange} style={{borderRadius:"10px",height:"50px"}} required/>
              </div>
          </div>
          <div class="row">
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Category Image{" "}</label>
            <input type="file" class="form-control" id="formFile" onChange={handleImageChange} name='profile'  style={{borderRadius:"10px",height:"50px"}} />
            </div>
          </div>
         <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"10px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"10px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Category </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2">
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Category Name</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Category Name" name='c_name' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"10px",height:"50px"}} required/>
               </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Category Code</label>
              <input type="text" class="form-control" id="floatingInput" placeholder="Category Code" name='c_code' value={formData.e_email} onChange={handleInputChange} style={{borderRadius:"10px",height:"50px"}} required/>
              </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Category Image{" "}</label>
            <input type="file" class="form-control" id="formFile" onChange={handleImageChange} name='profile'  style={{borderRadius:"10px",height:"50px"}} />
            </div>
            <div class="col" style={{zIndex:"2"}}>
            </div>
          </div>
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"10px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setCreate(false)} style={{borderRadius:"10px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Delivery Dates</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin:"15px 15px"}}>
  <h6>
    Order Id: <span style={{fontSize:"20px", color: "blue"}}>{currentOrder.order_no}</span>
  </h6>
  <h6 >
    Customer Name: <span style={{fontSize:"18px", color: "blue"}}>{currentOrder.customer_name}</span>
  </h6>
  <h6>
    Customer Mobile: <span style={{fontSize:"18px", color: "blue"}}>{currentOrder.mobile_no}</span>
  </h6>
</div>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Delivery Date</th>
          <th>Slot Name</th>
          <th>From Time</th>
          <th>To Time</th>
          <th>View List</th>

        </tr>
      </thead>
      <tbody>
  {bookingOrder.length > 0 ? (
    bookingOrder.map((dateItem, dateIndex) =>
      dateItem.slots.length > 0 ? (
        dateItem.slots.map((slot, slotIndex) => (
          <tr key={`${dateIndex}-${slotIndex}`} style={{ borderBottom: "1px solid #ddd" }}>
            <td>{slotIndex + 1}</td>
            <td>{dateItem.date}</td>
            <td>{slot.slot_name}</td>
            <td>{slot.from_time}</td>
            <td>{slot.to_time}</td>
            <td>
              <button className="btn btn-primary" onClick={() => handleshowItems(slot.order_items)}>
                <i style={{ color: "white", fontSize: "20px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr key={dateIndex}>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )
    )
  ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>
<Modal
  show={setOrdereditempopup}
  onHide={() => setOrderedItempopup(false)}
  backdrop="dynamic"
  keyboard={false}
  size="xl"
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>

          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Sub Variant</th>
          <th>Is Organic</th>
          <th>Remarks</th>
          <th>Additional Notes</th>
          <th>group foods</th>
        </tr>
      </thead>
      <tbody>
      {orderedItems.length > 0 ? (

      orderedItems.map((item, index) => (
          <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
            <td>{index + 1}</td>
            <img
  src={`${image_api}/${item.food_image}`}
  alt="item_image"
  width="50px"
  height="50px"
/>


            <td>{item.food_name}</td>
            <td>{item.item_code}</td>
            <td>{item.quantity}</td>
            <td>{item.unit_price}</td>
            <td>{item.variant_name}</td>
            <td>{item.sub_variant_name}</td>
            <td>{item.is_organic == 0 ? "Regular" : item.is_organic == 1 ? "Organic" : "N/A"}</td>
            <td>{item.remark}</td>
            <td>
  <div className="notes-cell" title={item.additional_notes}>
    {item.additional_notes}
  </div>
  </td>
  <td>
                  {item.group_items && item.group_items.length > 0 ? (
                    <span
                      style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                      onClick={() => handleGroupClick(item.group_items)}
                    >
                      {item.group_items.length} item(s)
                    </span>
                  ) : (
                    <span style={{ color: "gray" }}>No group foods</span>
                  )}
                </td>

          </tr>
          
        )))
        : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>

{/* Group Foods Modal */}
      <Modal show={showGroupModal} onHide={() => setShowGroupModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Group Foods</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedGroupFoods.length > 0 ? (
            <ul>
              {selectedGroupFoods.map((gf, idx) => (
                <li key={idx}>
                  <strong>{gf.group_name}</strong> - {gf.sub_group_name}
                </li>
              ))}
            </ul>
          ) : (
            <p>No group foods available.</p>
          )}
        </Modal.Body>
      </Modal>
       </Layout>
       </>  
    )
}

export default CancelledOrder;